import * as setup from 'setup';
import styled from 'styled-components';

export const FunnelZoomButtonElement = styled.button`
    background: transparent;
    border: none;
    padding: 0;

    &:not(:disabled) {
        cursor: pointer;
    }

    & > svg > path:first-child {
        fill: ${setup.colors.primary};
    }

    &:disabled > svg > path:first-child {
        fill: ${setup.colors.lightGrey};
    }
`;